import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import Select from "react-select";
import axios from "axios";
import { ReactMultiEmail } from "react-multi-email2";
import validator from "validator";
import ContentEditable from "react-contenteditable";
import Datetime from "react-datetime";
import moment from "moment";
import {
    Alert,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
import { OutputParamsDialog } from "./OutputParamsDialog";
import { getMomentLocaleByLang, truncStr, strip } from "../../utils/utils";
import ReactTooltip from "react-tooltip";

class WizardFormSecondPage extends React.Component {
    constructor(props) {
        super(props);
        var scriptParams = null,
            transportItems = null;
        if (
            props.selectedReport &&
            props.selectedReport.reportDefComponentsParams &&
            props.selectedReport.reportDefComponentsParams.length
        ) {
            scriptParams =
                props.selectedReport.reportDefComponentsParams[0] &&
                props.selectedReport.reportDefComponentsParams[0].data &&
                props.selectedReport.reportDefComponentsParams[0].data.scriptparams &&
                props.selectedReport.reportDefComponentsParams[0].data.scriptparams
                    .inputData;
            transportItems =
                props.selectedReport.reportDefComponentsParams[1] &&
                props.selectedReport.reportDefComponentsParams[1].data &&
                props.selectedReport.reportDefComponentsParams[1].data.transportitems;
        }
        var emailDeliveryState,
            emailSubject,
            emailTo,
            emailCC,
            emailBCC,
            sftpDeliveryState,
            ftpDeliveryState,
            ftpHost,
            ftpPort,
            ftpUserName,
            ftpUserPassword,
            ftpUploadPath;
        if (transportItems && transportItems.length) {
            transportItems.forEach((item, index) => {
                if (item.type === "Smtp") {
                    emailDeliveryState = true;
                    emailSubject = item.subject;
                    emailTo = item.to && item.to.split(";");
                    emailCC = item.cc && item.cc.split(";");
                    emailBCC = item.bcc && item.bcc.split(";");
                } else if (item.type === "Ftp") {
                    ftpDeliveryState = true;
                    ftpHost = item.host;
                    ftpPort = item.port;
                    ftpUserName = item.username;
                    ftpUserPassword = item.password;
                    ftpUploadPath = item.path;
                } else if (item.type === "Sftp") {
                    sftpDeliveryState = true;
                    ftpHost = item.host;
                    ftpPort = item.port;
                    ftpUserName = item.username;
                    ftpUserPassword = item.password;
                    ftpUploadPath = item.path;
                } else if (item.type === "FtpBackup") {
                    ftpHost = item.host;
                    ftpPort = item.port;
                    ftpUserName = item.username;
                    ftpUserPassword = item.password;
                    ftpUploadPath = item.path;
                }
            });
        }

        var _schItem = null;
        if (
            props.selectedReport &&
            props.selectedReport.schedules &&
            props.selectedReport.schedules[0]
        ) {
            _schItem = { ...props.selectedReport.schedules[0] };
        }

        var reportName = null;
        if (
            props.selectedReport &&
            props.selectedReport.reportDefComponentsParams &&
            props.selectedReport.reportDefComponentsParams[0] &&
            props.selectedReport.reportDefComponentsParams[0].data &&
            props.selectedReport.reportDefComponentsParams[0].data.reportName
        ) {
            reportName =
                props.selectedReport.reportDefComponentsParams[0].data.reportName;
        }
        let customerParam =
            props.selectedReportType &&
            props.selectedReportType.parameters &&
            props.selectedReportType.parameters.filter(
                (item) => item.paramName === "customer"
            )[0];

        let projectParam =
            props.selectedReportType &&
            props.selectedReportType.parameters &&
            props.selectedReportType.parameters.filter(
                (item) => item.paramName === "project"
            )[0];

        if (projectParam && projectParam.paramType === "project_list") {
            if (scriptParams && scriptParams.project) {
                scriptParams.projects = [scriptParams.project];
                delete scriptParams.project;
            }
        }
        if (!scriptParams) {
            const { user, subUser, isSubUser } = props;
            let currentUser = user;
            if (isSubUser) {
                currentUser = subUser;
            }
            scriptParams = {};
            props.selectedReportType &&
                props.selectedReportType.parameters &&
                props.selectedReportType.parameters.forEach((item) => {
                    if (item.defaultValue) {
                        scriptParams[item.paramName] = item.defaultValue;
                    } else if (item.paramType === "language") {
                        scriptParams[item.paramName] =
                            scriptParams[item.paramName] || currentUser?.language;
                    } else if (item.paramType === "timezone") {
                        scriptParams[item.paramName] =
                            scriptParams[item.paramName] || currentUser?.timeZone;
                    }
                });
        }
        const { user, subUser, isSubUser } = props;
        let currentUser = user;
        if (isSubUser) {
            currentUser = subUser;
        }
        const { customerGlobalId } = currentUser || {};

        let scheduleNextLaunch = null;
        if (_schItem) {
            scheduleNextLaunch = moment
                .utc(_schItem.nextlaunch, moment.ISO_8601)
                .toDate();
        } else {
            scheduleNextLaunch = moment
                .utc()
                .set({ hour: 8, minute: 0, second: 0, millisecond: 0 })
                .toDate();
        }

        this.state = {
            msg: {},
            params: {
                ...scriptParams,
                customer:
                    (props.selectedCustomer && props.selectedCustomer.GlobalId) ||
                    (scriptParams && scriptParams.customer) ||
                    (customerParam && customerParam.defaultValue) ||
                    (isSubUser ? customerGlobalId : null),
            },
            availableProjects: [],
            emailDeliveryState: emailDeliveryState || false,
            emailSubject: emailSubject || "",
            emailTo: emailTo || [],
            emailCC: emailCC || [],
            emailBCC: emailBCC || [],

            ftpDeliveryState: ftpDeliveryState || false,
            sftpDeliveryState: sftpDeliveryState || false,
            ftpHost: ftpHost || "",
            ftpPort: ftpPort || "",
            ftpUserName: ftpUserName || "",
            ftpUserPassword: ftpUserPassword || "",
            ftpUploadPath: ftpUploadPath || "",

            selectedCustomer: props.selectedCustomer,
            selectedCustomerName: "",

            scheduleRepeat: _schItem && _schItem.type,
            scheduleNextLaunch,

            reportName: reportName || "",

            outputParamsItem: null,
            outputParamsValueStr: "",
            outputParamsDialog: false,
            checkedOutputDefinedIds: [],
        };
    }

    outputParamsStringToArray = (valueString) => {
        var _res = [];
        var _paramStrArray = valueString.split(",");
        _paramStrArray.forEach((item) => {
            var _paramItems = item.split(":");
            if (_paramItems.length > 0) {
                _res.push({
                    id: _paramItems[0],
                    columnTitle: _paramItems[1] || "",
                });
            }
        });
        return _res;
    };

    openOutputParamsDialog = (item, value) => {
        window.__isReactDndBackendSetUp = false;
        this.setState({
            outputParamsDialog: !this.state.outputParamsDialog,
            outputParamsItem: item,
            outputParamsValueStr: value,
        });
    };

    toggleOutputParamsDialog = () => {
        this.setState({
            outputParamsDialog: !this.state.outputParamsDialog,
        });
    };

    onOutputParamsDialogSubmit = (outputParamsCheckedItems) => {
        // perform selection
        var _strResultArr = [];
        (outputParamsCheckedItems || []).forEach((item) => {
            if (item.checked && item.id) {
                _strResultArr.push(
                    (item.paramTitle || item.id || "") +
                    (item.columnTitle ? ":" + item.columnTitle : "")
                );
            }
        });
        const { params, outputParamsItem } = this.state;
        var _params = Object.assign({}, params);
        _params[outputParamsItem.paramName] = _strResultArr.join(",");
        this.setState({
            outputParamsDialog: !this.state.outputParamsDialog,
            params: _params,
        });
    };

    onSelectedCustomerChange(selectedCustomer, ignoreProjectReset) {
        var _params = this.state.params || {};
        let selectedCustomerName = "";
        if (selectedCustomer) {
            _params["customer"] = selectedCustomer.value;
            selectedCustomerName = selectedCustomer.label;
            if (!ignoreProjectReset) {
                delete _params["project"];
                delete _params["projects"];
            }
            this.loadAvailableProjects(selectedCustomer.value);
        } else {
            _params["customer"] = "";
            selectedCustomerName = "";
            if (!ignoreProjectReset) {
                delete _params["project"];
                delete _params["projects"];
            }
            this.setState({
                availableProjects: [],
            });
        }
        this.setState({
            params: _params,
            selectedCustomerName,
        });
    }

    loadAvailableProjects = (customerId) => {
        var me = this;
        axios
            .get("Configuration/customers/GetCustomer", {
                params: {
                    customerid: customerId,
                },
            })
            .then((response) => {
                if (me.isCurrent) {
                    //me.lastCustomerId.current = customerId;
                    if (response.data.Errors && response.data.Errors.length) {
                        me.setState({
                            availableProjects: [],
                        });
                    } else {
                        me.setState({
                            availableProjects: response.data.Data.Projects,
                        });
                    }
                }
            });
    };

    onSelectedProjectChange(selectedProject) {
        var _params = this.state.params || {};
        if (selectedProject) {
            _params["project"] = selectedProject.value;
        } else {
            _params["project"] = "";
        }
        this.setState({
            params: _params,
        });
    }

    onSelectedChannelChange = (selectedChannel) => {
        var _params = this.state.params || {};
        if (selectedChannel) {
            _params["channel"] = selectedChannel.value;
        } else {
            _params["channel"] = "";
        }
        this.setState({
            params: _params,
        });
    };

    onSelectedTimezoneChange = (selectedTimezone) => {
        var _params = this.state.params || {};
        if (selectedTimezone) {
            _params["timezone"] = selectedTimezone.value;
        } else {
            _params["timezone"] = "";
        }
        this.setState({
            params: _params,
        });
    };

    onSelectedLanguageChange = (selectedTimezone) => {
        var _params = this.state.params || {};
        if (selectedTimezone) {
            _params["language"] = selectedTimezone.value;
        } else {
            _params["language"] = "";
        }
        this.setState({
            params: _params,
        });
    };
    onFieldChange(e) {
        const { name, value, type, checked } = e.target;

        var _params = Object.assign({}, this.state.params);
        _params[name] = type === "checkbox" ? checked : value;
        this.setState({
            params: _params,
        });
    }

    onOutputFieldChange = (name, value) => {
        var _params = Object.assign({}, this.state.params);
        _params[name] = value;
        this.setState({
            params: _params,
        });
    };

    onOutputParametersChange = (name, value) => {
        var _params = Object.assign({}, this.state.params);
        _params[name] = value;
        this.setState({
            params: _params,
        });
    };

    onSelectedListChange(item, selectedItem) {
        var _params = this.state.params || {};
        if (selectedItem) {
            _params[item.paramName] = selectedItem.value;
        } else {
            _params[item.paramName] = "";
        }
        this.setState({
            params: _params,
        });
    }

    getParamField = (item) => {
        const {
            customers,
            channels,
            selectedCustomer,
            isActive,
            availableTimeZones,
        } = this.props;
        switch (item.paramType) {
            case "customer":
                let customerOptions = (customers || []).map((itm) => {
                    return { value: itm.globalId, label: itm.name };
                });
                /* let customerValue = this.state.params && this.state.params.customer;
                        if(!customerValue && !!isSubUser) {
                            customerValue = customerGlobalId;
                        } */
                return (
                    <Select
                        name="customerComboBox"
                        disabled={
                            !isActive || (selectedCustomer && !!selectedCustomer.GlobalId)
                        }
                        value={this.state.params && this.state.params.customer}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedCustomerChange.bind(this)}
                        options={customerOptions}
                    />
                );
            case "project":
                let projectOptions = (this.state.availableProjects || []).map((itm) => {
                    return { value: itm.projectId, label: itm.name };
                });
                return (
                    <Select
                        name="projectComboBox"
                        disabled={!isActive}
                        value={this.state.params && this.state.params.project}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedProjectChange.bind(this)}
                        options={projectOptions}
                    />
                );
            case "project_list":
                let _projectOptions = (this.state.availableProjects || []).map(
                    (itm) => {
                        return { value: itm.projectId, label: itm.name };
                    }
                );
                return (
                    <Select
                        name="projectComboBox"
                        disabled={!isActive}
                        multi={true}
                        className="multiselect-grid"
                        value={this.state.params && this.state.params.projects}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={(selectedProjects) => {
                            var _params = this.state.params || {};
                            if (selectedProjects && selectedProjects.length) {
                                const values = selectedProjects.map((item) => item.value);
                                _params["projects"] = values;
                            } else {
                                _params["projects"] = [];
                            }
                            this.setState({
                                params: _params,
                            });
                        }}
                        options={_projectOptions}
                    />
                );
            case "channel":
                let channelOptions = (channels || []).map((itm) => {
                    return { value: itm, label: itm };
                });
                return (
                    <Select
                        name="channelComboBox"
                        disabled={!isActive}
                        value={this.state.params && this.state.params.channel}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedChannelChange}
                        options={channelOptions}
                    />
                );
            case "timezone":
                var tzOptions = (availableTimeZones || []).map((item) => {
                    return { value: item.id, label: item.displayName };
                });
                return (
                    <Select
                        name="timeZoneId"
                        disabled={!isActive}
                        value={this.state.params && this.state.params.timezone}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedTimezoneChange}
                        options={tzOptions}
                    />
                );
            case "language":
                return (
                    <Select
                        name="languageId"
                        disabled={!isActive}
                        value={this.state.params && this.state.params.language}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedLanguageChange}
                        options={[
                            { value: "en-GB", label: "English (UK)" },
                            { value: "fi", label: "Finnish" },
                            { value: "no", label: "Norwegian" },
                            { value: "sv", label: "Swedish" },
                        ]}
                    />
                );
            case "string":
                return (
                    <input
                        disabled={!isActive}
                        type="text"
                        name={item.paramName}
                        value={this.state.params && this.state.params[item.paramName]}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onFieldChange.bind(this)}
                    />
                );
            case "output_parameters":
                return (
                    <ContentEditable
                        disabled={!isActive}
                        className={`output-params editable-output-input ${(this.state.params && this.state.params[item.paramName]) ||
                                item.defaultValue ||
                                ""
                                ? ""
                                : "show-placeholder"
                            }`}
                        html={
                            (this.state.params && this.state.params[item.paramName]) || ""
                        }
                        data-title={item.description || item.hint || item.paramDisplayName}
                        onClick={() =>
                            isActive &&
                            this.openOutputParamsDialog(
                                item,
                                this.state.params && this.state.params[item.paramName]
                            )
                        }
                        onChange={(e) =>
                            this.onOutputFieldChange(
                                item.paramName,
                                e.currentTarget.innerText
                            )
                        }
                    />
                );
            case "list":
                let listOptions = (item.values || []).map((row) => {
                    return { value: row, label: row };
                });
                return (
                    <Select
                        disabled={!isActive}
                        name={item.paramName}
                        value={this.state.params && this.state.params[item.paramName]}
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onSelectedListChange.bind(this, item)}
                        options={listOptions}
                    />
                );
            case "number":
                return (
                    <input
                        disabled={!isActive}
                        type="number"
                        name={item.paramName}
                        defaultValue={
                            (this.state.params && this.state.params[item.paramName]) ||
                            item.defaultValue
                        }
                        placeholder={item.description || item.hint || item.paramDisplayName}
                        onChange={this.onFieldChange.bind(this)}
                    />
                );
            case "bool":
                return [
                    <input
                        disabled={!isActive}
                        type="checkbox"
                        key="input-bool"
                        id={`${item.paramName}-checkbox`}
                        name={item.paramName}
                        style={{ border: "0px", paddingLeft: ".3rem" }}
                        defaultChecked={
                            (this.state.params && this.state.params[item.paramName]) ||
                            item.defaultValue
                        }
                        onChange={this.onFieldChange.bind(this)}
                    />,
                    <label key="label-bool" htmlFor={`${item.paramName}-checkbox`} />,
                ];
            default:
                break;
        }

        return <div />;
    };

    onReportNameChange(e) {
        this.setState({
            reportName: e.target.value,
        });
    }

    updateEmailDeliveryState() {
        this.setState({
            emailDeliveryState: !this.state.emailDeliveryState,
        });
        if (!this.state.emailDeliveryState) {
            var me = this;
            setTimeout(() => {
                me.emailSubjectInput && me.emailSubjectInput.focus();
            }, 700);
        }
    }

    onEmailSubjectChange(e) {
        this.setState({
            emailSubject: e.target.value,
        });
    }

    /* FTP/SFTP */
    updateFTPDeliveryState = () => {
        this.setState({
            ftpDeliveryState: !this.state.ftpDeliveryState,
            sftpDeliveryState: false,
            ftpPort: 21,
        });
        if (!this.state.ftpDeliveryState) {
            var me = this;
            setTimeout(() => {
                me.ftpHostInput && me.ftpHostInput.focus();
            }, 700);
        }
    };

    updateSFTPDeliveryState = () => {
        this.setState({
            sftpDeliveryState: !this.state.sftpDeliveryState,
            ftpDeliveryState: false,
            ftpPort: 22,
        });
        if (!this.state.sftpDeliveryState) {
            var me = this;
            setTimeout(() => {
                me.ftpHostInput && me.ftpHostInput.focus();
            }, 700);
        }
    };

    onFTPHostChange = (e) => {
        validator.isURL(e.target.value, { protocols: ["ftp", "sftp", "ftps"] })
            ? e.target.classList.remove("invalid")
            : e.target.classList.add("invalid");
        this.setState({
            ftpHost: e.target.value,
        });
    };

    onFTPPortChange(e) {
        validator.isPort(e.target.value)
            ? e.target.classList.remove("invalid")
            : e.target.classList.add("invalid");
        this.setState({
            ftpPort: e.target.value,
        });
    }

    onFTPUserNameChange(e) {
        this.setState({
            ftpUserName: e.target.value,
        });
    }

    onFTPUserPasswordChange(e) {
        this.setState({
            ftpUserPassword: e.target.value,
        });
    }

    onFTPUploadPathChange(e) {
        this.setState({
            ftpUploadPath: e.target.value,
        });
    }

    onSelectedSceduleRepeatChange(selectedItem) {
        if (selectedItem) {
            this.setState({
                scheduleRepeat: selectedItem.value,
            });
        } else {
            this.setState({
                scheduleRepeat: "",
            });
        }
    }

    handleFTPTestClick(e) {
        e.preventDefault();
        const {
            ftpDeliveryState,
            ftpHost,
            ftpPort,
            ftpUserName,
            ftpUserPassword,
            ftpUploadPath,
        } = this.state;

        if (ftpHost && ftpPort && ftpUserName && ftpUserPassword) {
            var me = this,
                params = {
                    IsSFTP: ftpDeliveryState,
                    Host: ftpHost,
                    Port: ftpPort,
                    Username: ftpUserName,
                    Password: ftpUserPassword,
                    Path: ftpUploadPath,
                };
            axios
                .post("Reporting/Pipelines/checkftpsftpconnection", params)
                .then((response) => {
                    if (response.data.Errors && response.data.Errors.length) {
                        me.setState({
                            msg: {
                                header: "FTP/SFTP Check",
                                message: (
                                    <Alert style={{ width: "650px" }} color="danger">
                                        FTP/SFTP test failed.
                                    </Alert>
                                ),
                            },
                        });
                    } else {
                        me.setState({
                            msg: {
                                header: "FTP/SFTP Check",
                                message: (
                                    <Alert style={{ width: "650px" }} color="success">
                                        FTP/SFTP test succeed.
                                    </Alert>
                                ),
                            },
                        });
                    }
                });
        } else {
            this.setState({
                msg: {
                    header: "FTP/SFTP Check",
                    message: (
                        <Alert style={{ width: "650px" }} color="danger">
                            The following fields are required for FTP/SFTP delivery
                            configuration:
                            <br />
                            Host, Port, Username, and Password.
                        </Alert>
                    ),
                },
            });
        }
    }

    toggleMsgBox = () => {
        this.setState({
            msg: {},
        });
    };

    handleReadMoreClick = (event) => {
        event.preventDefault();
        // show one more column
        const { toggleShowMoreDesc } = this.props;
        toggleShowMoreDesc(true);
    };

    handleReadLessClick = (event) => {
        event.preventDefault();
        this.props.toggleShowMoreDesc(false);
    };

    truncStrWithMore = (str, n) => {
        str = strip(str);
        const { showMoreDesc } = this.props;
        return (
            <span>
                {str.substr(0, n - 1)}
                {showMoreDesc ? (
                    <button
                        onClick={this.handleReadLessClick}
                        className="default-button-link"
                    >
                        ...less
                    </button>
                ) : (
                    <button
                        onClick={this.handleReadMoreClick}
                        className="default-button-link"
                    >
                        more...
                    </button>
                )}
            </span>
        );
    };

    componentDidMount() {
        const { selectedCustomer, params } = this.state;
        if (
            (selectedCustomer && selectedCustomer.GlobalId) ||
            (params && params.customer)
        ) {
            this.loadAvailableProjects(
                (selectedCustomer && selectedCustomer.GlobalId) ||
                (params && params.customer)
            );
        }
    }
    isCurrent = true;
    componentWillUnmount() {
        this.isCurrent = false;
    }

    render() {
        const {
            selectedReportType,
            user,
            subUser,
            isSubUser,
            showMoreDesc,
            isActive,
            translate,
        } = this.props;
        let currentUser = user;
        if (isSubUser) {
            currentUser = subUser;
        }
        const { language: userLanguage } = currentUser;
        const {
            emailDeliveryState,
            ftpDeliveryState,
            sftpDeliveryState,
            scheduleRepeat,
            scheduleNextLaunch,
            params,
        } = this.state;
        let atLeastOneParamInvalid = false;

        return (
            <div id="drag-drop-output-params2" className="grid-container-config">
                <table style={{ width: showMoreDesc ? "100%" : "745px" }}>
                    <tbody>
                        <tr />
                        <tr>
                            <td
                                className="grid-item param-name report-intro-container"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        selectedReportType &&
                                        selectedReportType.reportvisiblename &&
                                        truncStr(selectedReportType.reportvisiblename, 50),
                                }}
                            />
                            <td className="grid-item desc-container">
                                {selectedReportType &&
                                    selectedReportType.reportdescription &&
                                    this.truncStrWithMore(
                                        selectedReportType.reportdescription,
                                        100
                                    )}
                            </td>
                            {showMoreDesc && (
                                <td
                                    rowSpan="0"
                                    style={{ verticalAlign: "top" }}
                                    className="grid-item desc-container"
                                >
                                    {selectedReportType && selectedReportType.reportdescription && (
                                        <div
                                            style={{
                                                width: "650px",
                                                overflow: "auto",
                                                height: "100%",
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: selectedReportType.reportdescription,
                                            }}
                                        />
                                    )}
                                </td>
                            )}
                        </tr>
                        <tr>
                            <td className="grid-item" style={{ height: "1em" }} />
                            <td className="grid-item" />
                        </tr>
                        <tr key="sch-repeat-name">
                            <td className="grid-item param-name">Report name</td>
                            <td className="grid-item param-value">
                                <input
                                    type="text"
                                    disabled={!isActive}
                                    maxLength={100}
                                    placeholder='i.e. "delivered reminders" (optional)'
                                    defaultValue={this.state.reportName}
                                    onChange={this.onReportNameChange.bind(this)}
                                />
                            </td>
                        </tr>
                        {selectedReportType &&
                            selectedReportType.triggeredby === "Scheduler" && [
                                <tr key="sch-header">
                                    <td className="grid-item column-span-2" />
                                    <td className="grid-item wiz-table-header2 column-span-2">
                                        {translate("Schedule")}{" "}
                                        <>
                                            <button
                                                className="tooltip-btn"
                                                data-tip
                                                data-place="bottom"
                                                data-type="info"
                                                data-effect="solid"
                                                data-for={`schedule-tooltip`}
                                            >
                                                <i
                                                    className="fa fa-exclamation-circle"
                                                    style={{
                                                        fontSize: "0.8em",
                                                        margin: "0 0.4em",
                                                    }}
                                                />
                                            </button>
                                            <ReactTooltip
                                                className="customeTheme"
                                                id={`schedule-tooltip`}
                                            >
                                                <div
                                                    style={{ textTransform: "none", textAlign: "left" }}
                                                >
                                                    {translate("ScheduleToolTip")}
                                                </div>
                                            </ReactTooltip>
                                        </>
                                    </td>
                                </tr>,
                                <tr key="sch-repeat-name">
                                    <td className="grid-item param-name">Repeat</td>
                                    <td className="grid-item param-value">
                                        <Select
                                            disabled={!isActive}
                                            name="schedule-repeat"
                                            value={scheduleRepeat}
                                            placeholder="Select Schedule type..."
                                            onChange={this.onSelectedSceduleRepeatChange.bind(this)}
                                            options={[
                                                { value: "Hourly", label: "Hourly" },
                                                { value: "Daily", label: "Daily" },
                                                { value: "Monthly", label: "Monthly" },
                                                { value: "Weekly", label: "Weekly" },
                                            ]}
                                        />
                                    </td>
                                </tr>,
                                <tr key="sch-nextLaunch-name">
                                    <td className="grid-item param-name">Next launch</td>
                                    <td
                                        className={`grid-item param-value${!!isActive ? "" : " disabled"
                                            }`}
                                    >
                                        <div style={!!isActive ? { backgroundColor: "#fff" } : {}}>
                                            <Datetime
                                                value={
                                                    scheduleNextLaunch
                                                        ? scheduleNextLaunch instanceof Date
                                                            ? scheduleNextLaunch
                                                            : moment
                                                                .utc(scheduleNextLaunch, moment.ISO_8601)
                                                                .toDate()
                                                        : null
                                                }
                                                utc={true}
                                                locale={getMomentLocaleByLang(userLanguage)}
                                                dateFormat="DD-MM-YYYY"
                                                timeFormat="HH:mm"
                                                inputProps={{
                                                    placeholder: "dd-MM-yyyy HH:mm",
                                                    className: "--report-wizard-date-picker",
                                                    disabled: !isActive,
                                                }}
                                                onChange={(nextLaunch) => {
                                                    const _date = moment(nextLaunch).toDate();
                                                    this.setState({
                                                        scheduleNextLaunch:
                                                            _date instanceof Date ? _date : "",
                                                    });
                                                }}
                                                isValidDate={(currentDate) => {
                                                    var tomorrow = Datetime.moment();
                                                    return !isSubUser || currentDate.isAfter(tomorrow);
                                                }}
                                            />
                                            <div className="fa fa-calendar" />
                                        </div>
                                    </td>
                                </tr>,
                            ]}
                        {selectedReportType &&
                            selectedReportType.parameters &&
                            selectedReportType.parameters.length > 0 && [
                                <tr key="params-header1">
                                    <td className="grid-item column-span-2" />
                                    <td className="grid-item wiz-table-header2 column-span-2">
                                        Parameters
                                    </td>
                                </tr>,
                                [
                                    selectedReportType.parameters.map((item, index) => {
                                        let itemVisible = null;
                                        if (
                                            typeof item.visible === "string" ||
                                            item.visible instanceof String
                                        ) {
                                            itemVisible = false;
                                            selectedReportType.parameters
                                                .map((item) => item.paramName)
                                                .forEach((k) => {
                                                    if (item.visible.includes(k)) {
                                                        if (
                                                            // eslint-disable-next-line no-eval
                                                            eval(
                                                                item.visible.replace(k, 'params["' + k + '"]')
                                                            )
                                                        ) {
                                                            itemVisible = true;
                                                        }
                                                    }
                                                });
                                        } else {
                                            itemVisible = item.visible;
                                            if (itemVisible === false && !item.defaultValue) {
                                                atLeastOneParamInvalid = true;
                                            }
                                        }
                                        return (
                                            <tr
                                                key={`pn-${index}`}
                                                style={itemVisible === false ? { display: "none" } : {}}
                                            >
                                                <td className="grid-item param-name">
                                                    {item.paramDisplayName}
                                                </td>
                                                <td className="grid-item param-value">
                                                    {this.getParamField(item)}
                                                </td>
                                            </tr>
                                        );
                                    }),
                                ],
                            ]}
                        <tr>
                            <td className="grid-item column-span-2" />
                            <td className="grid-item wiz-table-header2 column-span-2">
                                Delivery configuration
                            </td>
                        </tr>

                        <tr>
                            <td className="grid-item" />
                            <td className="grid-item wiz-table-header3 column-span-2 wizard-checkbox">
                                <input
                                    type="checkbox"
                                    disabled={!isActive}
                                    id="emailDeliveryState"
                                    checked={this.state.emailDeliveryState}
                                    style={{ margin: 0 }}
                                    onChange={this.updateEmailDeliveryState.bind(this)}
                                />
                                <label
                                    htmlFor="emailDeliveryState"
                                    style={{ marginTop: "3px" }}
                                    className="form-check-label"
                                >
                                    Email
                                </label>
                            </td>
                        </tr>
                        {emailDeliveryState && (
                            <>
                                <tr>
                                    <td
                                        className={`grid-item param-name${emailDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Subject
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            type="text"
                                            ref={(input) => {
                                                this.emailSubjectInput = input;
                                            }}
                                            disabled={!emailDeliveryState || !isActive}
                                            maxLength={100}
                                            placeholder="Subject..."
                                            defaultValue={this.state.emailSubject}
                                            onChange={this.onEmailSubjectChange.bind(this)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${emailDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        To
                                    </td>
                                    <td
                                        className={`grid-item param-value${emailDeliveryState && isActive ? "" : " disabled"
                                            }`}
                                    >
                                        <ReactMultiEmail
                                            placeholder="To..."
                                            disabled={!emailDeliveryState || !isActive}
                                            emails={this.state.emailTo || []}
                                            onChange={(_emails) => {
                                                this.setState({ emailTo: _emails });
                                            }}
                                            getLabel={(email, index, removeEmail) => {
                                                return (
                                                    <label key={index}>
                                                        {email}
                                                        {emailDeliveryState && (
                                                            <span
                                                                className="fa fa-times"
                                                                style={{ margin: "0px 6px 0px 2px" }}
                                                                onClick={() => removeEmail(index)}
                                                            />
                                                        )}
                                                    </label>
                                                );
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${emailDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        CC
                                    </td>
                                    <td
                                        className={`grid-item param-value${emailDeliveryState && isActive ? "" : " disabled"
                                            }`}
                                    >
                                        <ReactMultiEmail
                                            placeholder="CC..."
                                            disabled={!emailDeliveryState || !isActive}
                                            emails={this.state.emailCC}
                                            onChange={(_emails) => {
                                                this.setState({ emailCC: _emails });
                                            }}
                                            getLabel={(email, index, removeEmail) => {
                                                return (
                                                    <label key={index}>
                                                        {email}
                                                        <span
                                                            className="fa fa-times"
                                                            style={{ margin: "0px 6px 0px 2px" }}
                                                            onClick={() => removeEmail(index)}
                                                        />
                                                    </label>
                                                );
                                            }}
                                        />
                                    </td>
                                </tr>
                                {!isSubUser && (
                                    <tr>
                                        <td
                                            className={`grid-item param-name${emailDeliveryState ? "" : " disabled"
                                                }`}
                                        >
                                            BCC
                                        </td>
                                        <td
                                            className={`grid-item param-value${emailDeliveryState && isActive ? "" : " disabled"
                                                }`}
                                        >
                                            <ReactMultiEmail
                                                placeholder="BCC..."
                                                disabled={!emailDeliveryState || !isActive}
                                                emails={this.state.emailBCC}
                                                onChange={(_emails) => {
                                                    this.setState({ emailBCC: _emails });
                                                }}
                                                getLabel={(email, index, removeEmail) => {
                                                    return (
                                                        <label key={index}>
                                                            {email}
                                                            <span
                                                                className="fa fa-times"
                                                                style={{ margin: "0px 6px 0px 2px" }}
                                                                onClick={() => removeEmail(index)}
                                                            />
                                                        </label>
                                                    );
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </>
                        )}
                        <tr>
                            <td style={{ padding: "0 0.5em" }} className="grid-item" />
                            <td className="grid-item wiz-table-header3 column-span-2 wizard-checkbox">
                                <input
                                    disabled={!isActive}
                                    type="checkbox"
                                    id="ftpDeliveryState"
                                    checked={ftpDeliveryState}
                                    style={{ margin: 0 }}
                                    onChange={this.updateFTPDeliveryState}
                                />
                                <label
                                    htmlFor="ftpDeliveryState"
                                    style={{ marginTop: "3px" }}
                                    className="form-check-label"
                                >
                                    FTP
                                </label>
                                /
                                <input
                                    disabled={!isActive}
                                    type="checkbox"
                                    id="sftpDeliveryState"
                                    checked={sftpDeliveryState}
                                    style={{ margin: 0 }}
                                    onChange={this.updateSFTPDeliveryState}
                                />
                                <label
                                    htmlFor="sftpDeliveryState"
                                    style={{ marginTop: "3px" }}
                                    className="form-check-label"
                                >
                                    SFTP
                                </label>
                                {(ftpDeliveryState || sftpDeliveryState) && this.state.ftpHost && (
                                    <button
                                        className="wizard-test-conn-btn"
                                        onClick={this.handleFTPTestClick.bind(this)}
                                    >
                                        Test connection
                                    </button>
                                )}
                            </td>
                        </tr>
                        {(ftpDeliveryState || sftpDeliveryState) && (
                            <>
                                <tr>
                                    <td
                                        className={`grid-item param-name${ftpDeliveryState || sftpDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Host / Server
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            disabled={!isActive}
                                            type="text"
                                            ref={(input) => {
                                                this.ftpHostInput = input;
                                            }}
                                            placeholder="Host / Server..."
                                            defaultValue={this.state.ftpHost}
                                            onChange={this.onFTPHostChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${ftpDeliveryState || sftpDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Port
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            disabled={!isActive}
                                            type="text"
                                            inputMode="numeric"
                                            placeholder="Port..."
                                            value={this.state.ftpPort}
                                            onChange={this.onFTPPortChange.bind(this)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${ftpDeliveryState || sftpDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Username
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            disabled={!isActive}
                                            type="text"
                                            maxLength={100}
                                            placeholder="Username..."
                                            defaultValue={this.state.ftpUserName}
                                            onChange={this.onFTPUserNameChange.bind(this)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${ftpDeliveryState || sftpDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Password
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            disabled={!isActive}
                                            type="password"
                                            maxLength={100}
                                            placeholder="Password..."
                                            defaultValue={this.state.ftpUserPassword}
                                            onChange={this.onFTPUserPasswordChange.bind(this)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className={`grid-item param-name${ftpDeliveryState || sftpDeliveryState ? "" : " disabled"
                                            }`}
                                    >
                                        Upload path/directory
                                    </td>
                                    <td className="grid-item param-value">
                                        <input
                                            disabled={!isActive}
                                            type="text"
                                            placeholder="Upload path/directory..."
                                            defaultValue={this.state.ftpUploadPath}
                                            onChange={this.onFTPUploadPathChange.bind(this)}
                                        />
                                    </td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
                {atLeastOneParamInvalid && (
                    <Alert style={{ margin: 0 }} color="warning">
                        Incorrect report definition in file ReportsDescription.json.
                    </Alert>
                )}
                <Modal
                    isOpen={!!this.state.msg.message}
                    style={{ maxWidth: "700px", maxHeight: "700px" }}
                    toggle={this.toggleMsgBox}
                >
                    {this.state.msg.header && (
                        <ModalHeader toggle={this.toggleMsgBox}>
                            {this.state.msg.header}
                        </ModalHeader>
                    )}
                    <ModalBody>{this.state.msg.message}</ModalBody>
                    <ModalFooter className="text-center">
                        <Button
                            color="primary"
                            className="switchBtn"
                            style={{ width: "100px" }}
                            onClick={this.toggleMsgBox}
                        >
                            {translate("OK")}
                        </Button>
                    </ModalFooter>
                </Modal>
                {this.state.outputParamsDialog && (
                    <OutputParamsDialog
                        outputParamsDialog={this.state.outputParamsDialog}
                        outputParamsItem={this.state.outputParamsItem}
                        outputParamsValueStr={this.state.outputParamsValueStr}
                        toggleOutputParamsDialog={this.toggleOutputParamsDialog}
                        onOutputParamsDialogSubmit={this.onOutputParamsDialogSubmit}
                        selectedCustomerId={params && params.customer}
                        selectedProjectId={params && params.project}
                    />
                )}
            </div>
        );
    }
}

/* function mapStateToProps(state) {
  const {
    config: { channels, customers },
    settings: { availableTimeZones },
    locale,
    authentication: { user, subUser, isSubUser },
  } = state;
  return {
    channels,
    customers,
    availableTimeZones,
    user,
    subUser,
    isSubUser,
    translate: getTranslate(locale),
  };
}

const connectedWizardFormSecondPage =
  connect(mapStateToProps)(WizardFormSecondPage);
export { connectedWizardFormSecondPage as WizardFormSecondPage }; */
export { WizardFormSecondPage };
